/* eslint-disable no-underscore-dangle */
import React, { useContext, useEffect, useState } from 'react';
import {
	LayerGroup,
	Marker,
	Popup,
	useMapEvents,
	GeoJSON,
} from 'react-leaflet';
import ReactDOMServer from 'react-dom/server';
import useMediaQuery from '@mui/material/useMediaQuery';
import * as L from 'leaflet';
import { RandomUUIDOptions } from 'crypto';
import { Grow } from '@mui/material';

import { LayerContext } from '../context/LayerContext';

import './leaflet-map.css';
import mapInfoUtils from '../../utils/mapInfoUtils';
import auctionsUtils from '../../utils/auctionsUtils';
import auctionLocationsUtils from '../../utils/auctionLocationsUtils';
import MegurimIcon from '../../img/megurimIcon.svg';
import MegurimIconSelected from '../../img/megurimIconSelected.svg';
import TaasukaIcon from '../../img/taasukaIcon.svg';
import TaasukaIconSelected from '../../img/taasukaIconSelected.svg';
import PointIcon from '../../img/pointIcon.svg';
import PointIconTaasuka from '../../img/pointIconTaasuka.svg';
import RedIcon from '../../img/red.svg';
import GreenIcon from '../../img/green.svg';
import RedIconTriangle from '../../img/redTriangle.svg';
import GreenIconTriangle from '../../img/greenTriangle.svg';

import PopupOccCard from '../Cards/PopupOccCard';
// /* eslint-disable  */

// function Popup2({ feature }) {
// 	let popupContent;
// 	if (feature.properties && feature.properties.popupContent) {
// 		popupContent = feature.properties.popupContent;
// 	}

// 	return (
// 		<div>
// 			<p>{`I started out as a GeoJSON  ${feature.geometry.type}, but now I'm a Leaflet vector!`}</p>
// 			{popupContent}
// 		</div>
// 	);
// }
// /* eslint-enable  */
function LoadMarker() {
	const {
		setAllPoints,
		setDrawedPoints,
		drawedPoints,
		selectedPointIdGlobal,
		setSelectedPointIdGlobal,
		activePark,
		setActivePark,
	} = useContext(LayerContext);
	// const [displayIcon, setDisplayIcon] = useState<Number>(0);
	const [locationData, setLocationData] = useState<any>([]);
	const isDesktop = useMediaQuery('(min-width:600px)');

	const [selectedPointIdLocal, setSelectedPointIdLocal] = useState<Number>(0);

	const [position, setPosition] = useState(null);
	const [mapData, setMapData] = useState({});
	const redIcon = L.icon({
		iconUrl: RedIcon,
		// iconSize: [38, 95],
		// iconAnchor: [-10, -10],
		popupAnchor: [8, 0],
		// // shadowUrl: 'my-icon-shadow.png',
		// shadowSize: [68, 95],
		// shadowAnchor: [22, 94],
	});
	const greenIcon = L.icon({
		iconUrl: GreenIcon,
		// iconSize: [38, 95],
		// iconAnchor: [22, 94],
		popupAnchor: [8, 0],
		// // shadowUrl: 'my-icon-shadow.png',
		// shadowSize: [68, 95],
		// shadowAnchor: [22, 94],
	});
	const map = useMapEvents({
		// on load of the map get markers and load them

		load(e) {
			// map.locate();
			console.log('map has loaded');
			// console.log(e);
			// console.log(e.target.getBounds());
		},
	});
	useEffect(() => {
		setSelectedPointIdLocal(selectedPointIdGlobal);
	}, [selectedPointIdGlobal]);
	function createIcon(url: any) {
		return new L.Icon({
			iconUrl: url,
		});
	}
	const getPointInfoById = (id: Number) => {
		console.log(id);
		const pointData = drawedPoints.find((x: any) => x._id === id);
		// console.log(pointData);
		setActivePark(pointData);
	};
	function handleClick(e: any) {
		setSelectedPointIdGlobal(e.target.options.index);
	}
	function getMarkerIcon(index: any, pointInfo: any) {
		// console.log(pointInfo);
		switch (pointInfo?.type!) {
			case 'תעסוקה':
				if (pointInfo?._id === selectedPointIdGlobal)
					return createIcon(GreenIconTriangle);
				return createIcon(RedIconTriangle);
			// break;

			default:
				if (pointInfo?._id === selectedPointIdGlobal)
					return createIcon(GreenIcon);
				return createIcon(RedIcon);
			// break;
		}
	}

	const onEachFeaturePoint = (feature: any, layer: any) => {
		// const popupContent = ReactDOMServer.renderToString(
		// 	<Popup feature={feature} />
		//   );
		//   layer.bindPopup(popupContent);

		// console.log('feature: ', feature);
		// console.log('layer: ', layer);
		// const popupContent = ReactDOMServer.renderToString(
		// 	<Popup2 feature={feature} />
		// );
		// // var rrose2 = new L.Rrose({ autoPan: false }).setContent(popupContent);
		// layer.bindPopup(popupContent, {
		// 	autoPan: false,
		// });
		layer.on({
			click(e: any) {
				console.log('e: ', e);
				console.log('click');
				getPointInfoById(parseInt(feature.id, 10));
				if (!isDesktop) setSelectedPointIdLocal(parseInt(feature.id, 10));
				// setActivePark(pointInfo);
				// setDisplayIcon(feature.id);
				// layer.setIcon((layer.options.icon = greenIcon));
			},
			mouseover(e: any) {
				getPointInfoById(parseInt(feature.id, 10));
				// setActivePark(null);
				//	console.log('e: ', e);
				console.log('hover');
				setSelectedPointIdLocal(parseInt(feature.id, 10));
			},
		});
	};
	const pointToLayer = (feature: any, latlng: any) =>
		L.marker(latlng, {
			icon:
				selectedPointIdLocal === parseInt(feature.id, 10) ? greenIcon : redIcon,
		}); // Change the icon to a custom icon

	useEffect(() => {
		const startTime = performance.now();
		const getAllPoints = async () => {
			const resp = await auctionsUtils.getAllAuctions(); // 1700ms
			const resp2 = await auctionLocationsUtils.getAllAuctionLocations(); // 500ms
			setLocationData(resp2.data);

			console.log(resp.data);
			setAllPoints(resp.data);
			setDrawedPoints(resp.data);
			
			const endTime = performance.now();
			console.log(
				`Call to doSomething took ${endTime - startTime} milliseconds`
			);
		};
		getAllPoints();
	}, []);

	return (
		<LayerGroup>
			<GeoJSON
				data={locationData}
				key={`geojson-${Math.random()}`}
				style={() => ({
					color: '#4a83ec',
					weight: 0.5,
					fillColor: '#1a1d62',
					fillOpacity: 1,
				})}
				pointToLayer={(feature, latlng) => pointToLayer(feature, latlng)}
				onEachFeature={(feature, layer) => onEachFeaturePoint(feature, layer)}
			/>

			{/* <Grow
				in={activePark ? false : true}
				style={{ transformOrigin: '0 0 0' }}
				{...(activePark ? false : true ? { timeout: 1000 } : {})}
			>
				<div> */}
			{true && activePark && (
				<Popup
					position={[activePark?.Location.Lat!, activePark?.Location.Lon!]}
					onClose={() => {
						setActivePark(null);
					}}
					autoPan={false}
					eventHandlers={{
						click: (e) => {
							console.log('marker clicked', e);
						},
					}} // style={{ textAlign: 'right' }}
				>
					{/* <div>
						<h2>{activePark.MichrazName}</h2>
						<p>{activePark.KodYeshuv}</p> */}

					<PopupOccCard
						// eslint-disable-next-line react/jsx-props-no-spreading
						{...activePark}
					/>
					{/* </div> */}
				</Popup>
			)}
			{/* </div>
			</Grow> */}
		</LayerGroup>

		// <Marker position={position}>
		// 	<Popup>You are here</Popup>
		// </Marker>
	);
}

export default LoadMarker;
